import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { StepThreeComponent } from './steps/step-three/step-three.component';
import { XeroSignUpComponent } from './steps/xero-sign-up/xero-sign-up.component';
import { SignupWizzardComponent } from './wizzard/signup-wizzard/signup-wizzard.component';
import { AuthGuard } from 'src/app/core/guard/auth.guard';
import { StepVerifyEmailComponent } from './steps/step-verify-email/step-verify-email.component';
import { StepConfirmEmailComponent } from './steps/step-confirm-email/step-confirm-email.component';
import { StepCreateAccountComponent } from './steps/step-create-account/step-create-account.component';
import { StepCaptureMethodsComponent } from './steps/step-capture-methods/step-capture-methods.component';
import { CaptureEmailSetupComponent } from './steps/capture-email-setup/capture-email-setup.component';
import { CaptureMobileSetupComponent } from './steps/capture-mobile-setup/capture-mobile-setup.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/signup/step-create-account',
    pathMatch: 'full'
  },
  {
    path: '',
    children: [
      // SD-1137: consolidated signup. step-one / step-two / step-two-company deleted.
      { path: 'step-create-account', component: StepCreateAccountComponent, pathMatch: 'full' },
      { path: 'step-one',            redirectTo: 'step-create-account',    pathMatch: 'full' },
      { path: 'step-two',            redirectTo: 'step-create-account',    pathMatch: 'full' },
      { path: 'step-two-company',    redirectTo: 'step-create-account',    pathMatch: 'full' },

      { path: 'steps-verify-email/:id', component: StepVerifyEmailComponent, pathMatch: 'full' },
      { path: 'steps-confirm-email/:id', component: StepConfirmEmailComponent },

      // Connect-accounting (PR-FE2) — legacy 'step-three' alias preserved.
      { path: 'step-three',                 component: StepThreeComponent, pathMatch: 'full' },
      { path: 'step-connect-accounting',    component: StepThreeComponent, pathMatch: 'full' },

      // Capture-methods flow (this PR).
      { path: 'step-capture-methods',   component: StepCaptureMethodsComponent, pathMatch: 'full' },
      { path: 'capture-email-setup',    component: CaptureEmailSetupComponent,  pathMatch: 'full' },
      { path: 'capture-mobile-setup',   component: CaptureMobileSetupComponent, pathMatch: 'full' },

      { path: 'xero-sign-up', component: XeroSignUpComponent, pathMatch: 'full' },
      { path: 'wizzard', canActivate: [AuthGuard], component: SignupWizzardComponent, pathMatch: 'full' }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignupRoutingModule { }
